import React, { useState, useEffect } from 'react';
import styles from './NextGame.module.css';

const NextGame = ({ onGameStatus }) => {
  const [gameData, setGameData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNextGame = async () => {
      try {
        const res = await fetch('/data/wba-next-game.json');
        const data = await res.json();
        setGameData(data);
        if (onGameStatus) onGameStatus(data.found);
      } catch {
        setGameData(null);
        if (onGameStatus) onGameStatus(false);
      } finally {
        setLoading(false);
      }
    };
    fetchNextGame();
  }, [onGameStatus]);

  if (loading) {
    return (
      <section id="next-game" className="section section--alt">
        <div className="section__inner">
          <h2 className="section__title">Next Game</h2>
          <div className={styles.loading}>Checking the schedule...</div>
        </div>
      </section>
    );
  }

  if (!gameData || !gameData.found || !gameData.game) {
    return (
      <section id="next-game" className="section section--alt">
        <div className="section__inner">
          <h2 className="section__title">Next Game</h2>
          <div className={styles.fallback}>
            <h3 className={styles.fallbackTitle}>
              CONTACT YOUR LOCAL PUMA FOR A DATE
            </h3>
            <p className={styles.fallbackSub}>
              Or check out yourself at{' '}
              <a
                href="https://ligawba.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--puma-spot2)', textDecoration: 'underline' }}
              >
                ligawba.com
              </a>
            </p>
          </div>
        </div>
      </section>
    );
  }

  const game = gameData.game;
  const gameDate = new Date(game.date);
  const dateStr = gameDate.toLocaleDateString('pl-PL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const timeStr = game.time || gameDate.toLocaleTimeString('pl-PL', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <section id="next-game" className="section section--alt">
      <div className="section__inner">
        <h2 className="section__title">Next Game</h2>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <span className={styles.league}>{game.league || 'Liga WBA'}</span>
            {game.round && <span className={styles.round}>{game.round}</span>}
          </div>
          <div className={styles.matchup}>
            <div className={styles.team}>
              <div className={styles.teamBadge}>PUM</div>
              <span className={styles.teamName}>PUMY BETONU</span>
            </div>
            <div className={styles.vs}>VS</div>
            <div className={styles.team}>
              <div className={styles.teamBadge}>
                {game.opponentShort || '???'}
              </div>
              <span className={styles.teamName}>{game.opponent}</span>
            </div>
          </div>
          <div className={styles.details}>
            <div className={styles.detail}>
              <span className={styles.detailLabel}>DATE</span>
              <span className={styles.detailValue}>{dateStr}</span>
            </div>
            <div className={styles.detail}>
              <span className={styles.detailLabel}>TIME</span>
              <span className={styles.detailValue}>{timeStr}</span>
            </div>
            {game.venue && (
              <div className={styles.detail}>
                <span className={styles.detailLabel}>VENUE</span>
                <span className={styles.detailValue}>{game.venue}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NextGame;
